// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

export const normalizeGraphQLConnection = connectionData =>
  connectionData.edges.map(({ node = {} } = {}) => ({ ...node }))



// WEBPACK FOOTER //
// ./src/shared/graphql/utils.js